import guid from './guid';
import isLocalStorageAvailable from './isLocalStorageAvailable';

function getAuthData(projectId, data, uuid = null) {
    var authData = {};
    var curUuid, uuidKey;

    if (isLocalStorageAvailable() && authData && !uuid) {
        uuidKey = 'alan-btn-uuid-' + projectId;
        curUuid = localStorage.getItem(uuidKey);
        if (curUuid) {
            authData.uuid = curUuid;
        } else {
            authData.uuid = guid();
            localStorage.setItem(uuidKey, authData.uuid);
        }
    } else {
        authData.uuid = guid();
    }

    authData.auth = data;
    return authData;
}

export default getAuthData;
